import React, { Component } from 'react'
import { Form, FormField, Dialog, LinkButton, ComboBox, Panel, Messager, TextBox, MaskedBox, DateBox, NumberBox } from 'rc-easyui';
import { getCookie, getAccessToken } from '../../../helpers/cookieHelper';
import { API_URL } from "../../../constants";

import { Button } from 'reactstrap';
import { getFormattedDate, isEmpty } from "../../../helpers";
import { autoDissaperAction } from "../../../helpers/index";
import { getUserId } from '../../../helpers/AuthHelper';
import ViewTimesheetSystem from './ViewTimesheetSystem';

const axios = require("axios");

class CreateTimesheetSystem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      mydata: [],
      ID: [{ fid: "", id: "" }],
      title: 'Submit',
      closed: true,
      formId: null,
      check: null
    }
  }

  //   handleSave = async (id) => {
  //     let token = getCookie("access_token");
  //     let tokenType = getCookie("token_type");
  //     let formSave = {}
  //     let formUpdate = {}
  //     let temp = [...this.props.timeSheet]
  //     let action = null
  //     let uid = null

  //     this.setState({closed:true})
  // console.log(id);
  //     temp.map(f => {
  //       if (f.fid == id) {
  //         this.state.ID.map(d => {
  //           if (d.fid == id) {
  //             console.log(d.fid);
  //             console.log('update');
  //             action = "update"
  //             formUpdate = {
  //               projectId: f.projectId,
  //               subprojectId: f.subprojectId,
  //               description: f.description,
  //               enabled: true,
  //               userId: this.props.userId,
  //               timeSpent:this.props.validateTimeSpent(f.timeSpent) ,
  //               status: "Submitted",
  //               comments: " ",
  //               dateBs: getFormattedDate(f.dateBs),
  //               id: d.id
  //             }
  //           } else {
  //             console.log('save');
  //             action = "save"
  //             formSave = {
  //               projectId: f.projectId,
  //               subprojectId: f.subprojectId,
  //               description: f.description,
  //               enabled: true,
  //               userId: this.props.userId,
  //               timeSpent: this.props.validateTimeSpent(f.timeSpent),
  //               status: "Submitted",
  //               comments: " ",
  //               dateBs: getFormattedDate(f.dateBs)
  //             }
  //           }
  //         })

  //       }
  //     })


  //     let apiUrl = `${API_URL}api/savetimesheet`;
  //     let headersConfig = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `${tokenType} ${token}`,
  //       },
  //     };
  //     this.props.innerRef.current.validate(async (errors) => {
  //       if (isEmpty(errors)) {
  //         //No Form Validation Error
  //         if (token != null) {
  //           //Access Token Available
  //           this.setState({
  //             isLoading: true,
  //           });
  //           if (action == "save") {
  //             axios
  //               .post(apiUrl, formSave, headersConfig)
  //               .then((response) => {
  //                 console.log(response)
  //                 if (response.status === 200) {
  //                   this.ViewTimesheetSystem.getData();
  //                   this.setState({
  //                     isLoading: false,
  //                   });
  //                   if (response.data.status) {
  //                     this.props.buttonHandler(id, 'saved');
  //                     this.messager.alert({
  //                       title: "Success",
  //                       msg: response.data.message,
  //                       icon: "info",
  //                       reload: false,
  //                       buttons: [
  //                         {
  //                           text: "ok",
  //                           onClick: () => {
  //                             window.location.reload();
  //                           },
  //                         },
  //                       ],
  //                     }); // script detail  Saved Successfully ie. 200
  //                     // autoDissaperAction();
  //                   } else {
  //                     this.messager.alert({
  //                       title: "Error",
  //                       msg: response.data.message,
  //                     });
  //                   }
  //                   // this.props.formClear();
  //                 } else {
  //                   this.messager.alert({
  //                     title: "Error",
  //                     msg: "Uncaught Error",
  //                     reload: false,
  //                   });
  //                 }
  //               })
  //               .catch((error) => {
  //                 this.setState({
  //                   isLoading: false,
  //                 });
  //                 this.messager.alert({
  //                   title: "Error",
  //                   msg: "Internal Server Error",
  //                   reload: false,
  //                 });
  //                 var response = error["response"];
  //                 if (response !== undefined) {
  //                   if (response.status === 400) {
  //                     var message = "";
  //                     response.data.errors.forEach((row, i) => {
  //                       message +=
  //                         "<p style='margin-bottom:3px;'>" +
  //                         row.field.toUpperCase() +
  //                         " " +
  //                         row.defaultMessage +
  //                         "</p>";
  //                     });
  //                     this.messager.alert({
  //                       title: "Error",
  //                       msg: message,
  //                       reload: false,
  //                     }); // Backend Validation Error ie.400
  //                   } else {
  //                     this.messager.alert({
  //                       title: "Error",
  //                       msg: "UnCaught Error",
  //                       reload: false,
  //                     }); // Uncaught Backend Error ie.500 eyc.
  //                   }
  //                 } else {
  //                   this.messager.alert({
  //                     title: "Error",
  //                     msg: "Internal Server Error",
  //                     reload: false,
  //                   }); // Caused due to syntax error in front end
  //                 }
  //               });
  //           } 
  //           if(action=='update') {
  //             axios
  //               .put(apiUrl, formUpdate, headersConfig)
  //               .then((response) => {
  //                 console.log(response)
  //                 if (response.status === 200) {
  //                   this.ViewTimesheetSystem.getData();
  //                   this.setState({
  //                     isLoading: false,
  //                   });
  //                   if (response.data.status) {
  //                     this.props.buttonHandler(id, 'saved');
  //                     this.messager.alert({
  //                       title: "Success",
  //                       msg: response.data.message,
  //                       icon: "info",
  //                       reload: false,
  //                       buttons: [
  //                         {
  //                           text: "ok",
  //                           onClick: () => {
  //                             window.location.reload();
  //                           },
  //                         },
  //                       ],
  //                     }); // script detail  Saved Successfully ie. 200
  //                     // autoDissaperAction();
  //                   } else {
  //                     this.messager.alert({
  //                       title: "Error",
  //                       msg: response.data.message,
  //                     });
  //                   }
  //                   // this.props.formClear();
  //                 } else {
  //                   this.messager.alert({
  //                     title: "Error",
  //                     msg: "Uncaught Error",
  //                     reload: false,
  //                   });
  //                 }
  //               })
  //               .catch((error) => {
  //                 this.setState({
  //                   isLoading: false,
  //                 });
  //                 this.messager.alert({
  //                   title: "Error",
  //                   msg: "Internal Server Error",
  //                   reload: false,
  //                 });
  //                 var response = error["response"];
  //                 if (response !== undefined) {
  //                   if (response.status === 400) {
  //                     var message = "";
  //                     response.data.errors.forEach((row, i) => {
  //                       message +=
  //                         "<p style='margin-bottom:3px;'>" +
  //                         row.field.toUpperCase() +
  //                         " " +
  //                         row.defaultMessage +
  //                         "</p>";
  //                     });
  //                     this.messager.alert({
  //                       title: "Error",
  //                       msg: message,
  //                       reload: false,
  //                     }); // Backend Validation Error ie.400
  //                   } else {
  //                     this.messager.alert({
  //                       title: "Error",
  //                       msg: "UnCaught Error",
  //                       reload: false,
  //                     }); // Uncaught Backend Error ie.500 eyc.
  //                   }
  //                 } else {
  //                   this.messager.alert({
  //                     title: "Error",
  //                     msg: "Internal Server Error",
  //                     reload: false,
  //                   }); // Caused due to syntax error in front end
  //                 }
  //               });
  //           }
  //         } else {
  //           //Access Token Expired.
  //           //Generate new Access Token using Refresh Token.
  //           const resp = await getAccessToken();
  //           if (resp) {
  //             this.handleSave();
  //           }
  //         }
  //       } else {
  //       }
  //     });

  //   }

  handleSave = async (id) => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let formSave = {}
    let formUpdate = {}
    let temp = [...this.props.timeSheet]
    let action = null
    let uid = null

    this.setState({ closed: true })
    temp.map(f => {
      if (f.fid == id) {
        let myArray = this.state.ID
        formSave = {
          projectId: f.projectId,
          subprojectId: f.subprojectId,
          description: f.description,
          enabled: true,
          userId: this.props.userId,
          timeSpent: this.props.validateTimeSpent(f.timeSpent),
          status: "Submitted",
          comments: " ",
          dateBs: getFormattedDate(f.dateBs)
        }
        for (var i = 0; i < myArray.length; i++) {
          if (myArray[i].fid == id) {
            action = "update"
            formUpdate = {
              projectId: f.projectId,
              subprojectId: f.subprojectId,
              description: f.description,
              enabled: true,
              userId: this.props.userId,
              timeSpent: this.props.validateTimeSpent(f.timeSpent),
              status: "Submitted",
              comments: " ",
              dateBs: getFormattedDate(f.dateBs),
              id: myArray[i].id
            }
            break;
          }
        }
      }
    })


    let apiUrl = `${API_URL}api/savetimesheet`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          if (action == "update") {
            axios
              .put(apiUrl, formUpdate, headersConfig)
              .then((response) => {
                console.log(response)
                if (response.status === 200) {
                  this.ViewTimesheetSystem.getData();
                  this.setState({
                    isLoading: false,
                  });
                  if (response.data.status) {
                    this.props.buttonHandler(id, 'saved');
                    this.messager.alert({
                      title: "Success",
                      msg: response.data.message,
                      icon: "info",
                      reload: false,
                      buttons: [
                        {
                          text: "ok",
                          onClick: () => {
                            window.location.reload();
                          },
                        },
                      ],
                    }); // script detail  Saved Successfully ie. 200
                    // autoDissaperAction();
                  } else {
                    this.messager.alert({
                      title: "Error",
                      msg: response.data.message,
                    });
                  }
                  // this.props.formClear();
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "Uncaught Error",
                    reload: false,
                  });
                }
              })
              .catch((error) => {
                this.setState({
                  isLoading: false,
                });
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                });
                var response = error["response"];
                if (response !== undefined) {
                  if (response.status === 400) {
                    var message = "";
                    response.data.errors.forEach((row, i) => {
                      message +=
                        "<p style='margin-bottom:3px;'>" +
                        row.field.toUpperCase() +
                        " " +
                        row.defaultMessage +
                        "</p>";
                    });
                    this.messager.alert({
                      title: "Error",
                      msg: message,
                      reload: false,
                    }); // Backend Validation Error ie.400
                  } else {
                    this.messager.alert({
                      title: "Error",
                      msg: "UnCaught Error",
                      reload: false,
                    }); // Uncaught Backend Error ie.500 eyc.
                  }
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "Internal Server Error",
                    reload: false,
                  }); // Caused due to syntax error in front end
                }
              });

          }
          else {
            axios
              .post(apiUrl, formSave, headersConfig)
              .then((response) => {
                console.log(response)
                if (response.status === 200) {
                  this.ViewTimesheetSystem.getData();
                  this.setState({
                    isLoading: false,
                  });
                  if (response.data.status) {
                    this.props.buttonHandler(id, 'saved');
                    this.messager.alert({
                      title: "Success",
                      msg: response.data.message,
                      icon: "info",
                      reload: false,
                      buttons: [
                        {
                          text: "ok",
                          onClick: () => {
                            window.location.reload();
                          },
                        },
                      ],
                    }); // script detail  Saved Successfully ie. 200
                    // autoDissaperAction();
                  } else {
                    this.messager.alert({
                      title: "Error",
                      msg: response.data.message,
                    });
                  }
                  // this.props.formClear();
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "Uncaught Error",
                    reload: false,
                  });
                }
              })
              .catch((error) => {
                this.setState({
                  isLoading: false,
                });
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                });
                var response = error["response"];
                if (response !== undefined) {
                  if (response.status === 400) {
                    var message = "";
                    response.data.errors.forEach((row, i) => {
                      message +=
                        "<p style='margin-bottom:3px;'>" +
                        row.field.toUpperCase() +
                        " " +
                        row.defaultMessage +
                        "</p>";
                    });
                    this.messager.alert({
                      title: "Error",
                      msg: message,
                      reload: false,
                    }); // Backend Validation Error ie.400
                  } else {
                    this.messager.alert({
                      title: "Error",
                      msg: "UnCaught Error",
                      reload: false,
                    }); // Uncaught Backend Error ie.500 eyc.
                  }
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "Internal Server Error",
                    reload: false,
                  }); // Caused due to syntax error in front end
                }
              });
          }
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
      }
    });

  }

  setID = (id, myid) => {
    this.setState({
      ID: [...this.state.ID, {
        fid: id,
        id: myid
      }]
    })
  }
  // callSetId=(id,myid)=>{
  //   this.props.setID(id,myid)
  // }



  handleDraft = (id) => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = {}
    let temp = [...this.props.timeSheet]
    temp.map(f => {
      if (f.fid === id) {
        form = {
          projectId: f.projectId,
          subprojectId: f.subprojectId,
          description: f.description,
          enabled: true,
          userId: this.props.userId,
          timeSpent: this.props.validateTimeSpent(f.timeSpent),
          status: "Draft",
          comments: " ",
          dateBs: getFormattedDate(f.dateBs)
        }
      }
    })
    let apiUrl = `${API_URL}api/savetimesheet`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(apiUrl, form, headersConfig)
            .then((response) => {
              //  console.log(response)
              if (response.status === 200) {
                this.ViewTimesheetSystem.getData();
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.props.buttonHandler(id, 'drafted');
                  let myid = response.data.object.id
                  this.setID(id, myid)
                  // this.callSetId(id,myid)
                  this.messager.alert({
                    title: "Success",
                    msg: 'Data saved in draft successfully',
                    icon: "info",
                    reload: false,
                    buttons: [
                      {
                        text: "ok",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  }); // script detail  Saved Successfully ie. 200
                  // autoDissaperAction();
                  // this.props.removeForm(id)
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleDraft();
          }
        }
      } else {
      }
    });

  }



  handleUpdate = (id) => {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = {}
    let temp = [...this.props.timeSheet]
    temp.map(f => {
      if (f.fid === id) {
        if (f.operation === "editClick") {
          form = {
            projectId: f.projectId,
            subprojectId: f.subprojectId,
            description: f.description,
            enabled: true,
            userId: this.props.userId,
            timeSpent: this.props.validateTimeSpent(f.timeSpent),
            status: "Draft",
            comments: " ",
            dateBs: getFormattedDate(f.dateBs),
            id: f.id
          }
        } else {
          this.state.ID.map(d => {
            if (d.fid === id) {
              form = {
                projectId: f.projectId,
                subprojectId: f.subprojectId,
                description: f.description,
                enabled: true,
                userId: this.props.userId,
                timeSpent: this.props.validateTimeSpent(f.timeSpent),
                status: "Draft",
                comments: " ",
                dateBs: getFormattedDate(f.dateBs),
                id: d.id
              }
            }
          })

        }

      }
    })
    // console.log(form)
    let apiUrl = `${API_URL}api/savetimesheet`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .put(apiUrl, form, headersConfig)
            .then((response) => {
              //  console.log(response)
              if (response.status === 200) {
                this.props.clearSelected()
                this.ViewTimesheetSystem.getData();
                // this.props.removeForm(id)
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.props.buttonHandler(id, 'drafted');
                  this.messager.alert({
                    title: "Success",
                    msg: 'Data updated in draft successfully',
                    icon: "info",
                    reload: false,
                    buttons: [
                      {
                        text: "ok",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  }); // script detail  Saved Successfully ie. 200
                  // autoDissaperAction();
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message + "hello",
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
      }
    });

  }

  viewData = (data) => {
    this.setState({ mydata: data })
  }

  renderDialog() {
    const row = this.state.model;
    const { title, closed, rules } = this.state;
    return (
      <Dialog modal title={title} closed={closed} onClose={() => this.setState({ closed: true, btn: null })}>
        <div className="f-full" style={{ padding: '20px 50px' }}>
          <Form className="f-full"
            ref={ref => this.form = ref}
            model={row}
          // rules={rules}
          // onValidate={(errors) => this.setState({ errors: errors })}
          // onChange={(e)=>this.handeleChange()}
          >
            <div style={{ marginBottom: 10 }}>
              <h6>Are you sure you want to submit this timesheet?
                <br></br>Once submitted, you won't be able to edit this timesheet.</h6>


              {/* <div className="error">{this.getError('comments')}</div> */}
            </div>
          </Form>
        </div>
        <div className="dialog-button">
          <LinkButton className="btn btn-primary" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.handleSave(this.state.formId)}>Yes</LinkButton>
          <LinkButton className="btn btn-danger" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.setState({ closed: true })}>No</LinkButton>
        </div>
      </Dialog>
    )
  }

  onSubmitClick = (formId) => {
    this.setState({
      closed: false,
      formId: formId
    })
  }


  render() {
    const { operation, timeSheet, rules, handleChange, permissions, onSelectionChange, projectList, subprojectList, handleSave, addForm } = this.props
    const { isLoading } = this.state.isLoading;
    return (
      <div>
        <Panel title='Timesheet System' bodyStyle={{ padding: 20 }}>

          {
            timeSheet.map(form => {
              return (
                <div>
                  <Messager
                    ref={(ref) => (this.messager = ref)}
                    showHeader={false}
                    borderType='none'
                    content={({ title, msg, buttons, reload }) => (
                      <div className='alert-content'>
                        <h3>{title}</h3>
                        <div
                          style={{ marginBottom: 5 }}
                          dangerouslySetInnerHTML={{ __html: msg }}
                        ></div>
                        <div className='m-buttons'>
                          {buttons.map((button, index) => (
                            <LinkButton
                              key={index}
                              text={button.text}
                              onClick={() => {
                                this.messager.close(button);
                                if (reload) {
                                  window.location.reload();
                                }
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  />
                  <div
                    className='loadingmodel'
                    style={{ display: isLoading ? "block" : "none" }}
                  ></div>
                  <Form
                    ref={this.props.innerRef}
                    style={{ maxWidth: 500 }}
                    model={form}
                    labelWidth={170}
                    labelAlign="left"
                    labelPosition='top'
                    onChange={(e) => handleChange(e, form.id)}
                    rules={rules}>
                    <div>

                      <div style={{ display: "flex", textAlign: "center" }}>
                        <div style={{ marginRight: "10px", width: "200px" }}>
                          <FormField key={form.fid} name="dateBs" label="Date">
                            {/* <MaskedBox
                              mask="9999-99-99"
                              value={form.dateBs}
                              disabled={form.btn2 === true ? true : false}
                            >
                            </MaskedBox> */}
                            <DateBox
                              style={{ width: "200px" }}
                              format="yyyy-MM-dd"
                              value={form.dateBs}
                              disabled={form.btn2 === true ? true : false}
                            ></DateBox>
                          </FormField>
                        </div>
                        <div style={{ marginRight: "10px", width: "150px" }}>
                          <FormField key={form.fid} name="projectId" label="Project">
                            <ComboBox
                              style={{ width: "100%" }}
                              data={projectList}
                              value={form.projectId}
                              valueField="id"
                              textField="name"
                              // editable={form.btn2===false ? false:true}
                              disabled={form.btn2 === true ? true : false}
                            // onChange={(e)=>this.handleChange()}
                            >
                            </ComboBox>
                          </FormField>
                        </div>
                        <div style={{ marginRight: "10px", width: "150px" }}>
                          <FormField key={form.fid} name="subprojectId" label="Sub-Project">
                            <ComboBox
                              style={{ width: "100%" }}
                              data={subprojectList}
                              value={form.subprojectId}
                              valueField="id"
                              textField="name"
                              // editable={form.btn2===false ? false:true}
                              disabled={form.btn2 === true ? true : false}
                            // onChange={(e)=>this.handleChange()}
                            >

                            </ComboBox>
                          </FormField>
                        </div>
                        <div style={{ marginRight: "10px", flexBasis: "400px" }}>
                          <FormField key={form.fid} name="description" label="Description" >
                            <TextBox
                              style={{ width: "400px" }}
                              value={form.description}
                              editable={form.btn2 === true ? false : true}
                            // onChange={(e)=>this.handleChange(e,form.formId)}
                            ></TextBox>
                          </FormField>
                        </div>
                        <div style={{ marginRight: "10px", width: "80px" }}>
                          <FormField key={form.fid} name="timeSpent" label="Time Spent" >
                            <NumberBox value={form.timeSpent} suffix="H" style={{ width: "100%" }} placeholder="Hour" disabled={form.btn2 === true ? true : false} spinners={false}></NumberBox>
                          </FormField>
                        </div>
                        {
                          !form.btn2 &&
                          <>
                            <div style={{ marginLeft: "10px" }}>
                              <FormField>
                                <div style={{ marginTop: "25px" }}>
                                  <Button
                                    color={form.btn1 === 'draft' ? 'primary' : 'success'}
                                    disabled={isLoading ? true : false}
                                    onClick={
                                      form.btn1 === "draft" ? () => this.handleDraft(form.fid) : () => this.handleUpdate(form.fid)
                                    }
                                    style={{ marginRight: 5 }}
                                  >
                                    {/* {form.btn1 === "draft" ? "Draft" : "Update"} */}
                                    Draft
                                  </Button>
                                </div>
                              </FormField>
                            </div>
                            <div>
                              <FormField>
                                <div style={{ marginTop: "25px" }}>
                                  {/* <Button color={form.btn2 === false ? 'primary' : 'success'} onClick={() => this.handleSave(form.fid)}> */}

                                  <Button color={form.btn2 === false ? 'primary' : 'success'} onClick={() => this.onSubmitClick(form.fid)}>
                                    Submit
                                  </Button>
                                </div>
                              </FormField>
                            </div>
                          </>
                        }
                        {form.btn2 &&
                          <div>
                            <FormField>
                              <div style={{ marginTop: "25px" }}>
                                <Button color="success" disabled={true}>
                                  Submitted
                                </Button>
                              </div>
                            </FormField>
                          </div>
                        }
                      </div>
                    </div>
                  </Form>
                  {this.renderDialog()}
                </div>
              )
            }
            )
          }

          <div style={{ marginTop: "10px" }}>
            <Button color='info' onClick={addForm}>+</Button>
          </div>


          {
            permissions.includes("timesheet-view") ? (
              <div style={{ marginTop: "10px" }}>
                <ViewTimesheetSystem
                  ref={instance => { this.ViewTimesheetSystem = instance; }}
                  projectList={projectList}
                  subprojectList={subprojectList}
                  onSelectionChange={onSelectionChange}
                  permissions={permissions}
                  selected={this.props.selected}
                  onEditClick={this.props.onEditClick}
                  viewData={this.viewData}
                  clearSelected={this.props.clearSelected}
                  validateTimeSpent={this.props.validateTimeSpent}
                  userId={this.props.userId}
                  getUsers={this.props.getUsers}
                  setUserId={this.props.setUserId}
                />
              </div>
            ) : null
          }


        </Panel>
      </div>
    )
  }
}
export default React.forwardRef((props, ref) => (
  <CreateTimesheetSystem innerRef={ref} {...props} />
))
